import { Monitor, Zap, DollarSign, Target } from "lucide-react";

const factors = [
  {
    icon: Monitor,
    title: "E-Filing Systems",
    desc: "Courts increasingly operate through electronic filing systems",
  },
  {
    icon: Zap,
    title: "AI Adoption",
    desc: "Law firms are more willing than ever to adopt AI-driven tools",
  },
  {
    icon: DollarSign,
    title: "Cost Pressure",
    desc: "Clients are pushing firms to reduce avoidable legal costs",
  },
  {
    icon: Target,
    title: "Category Gap",
    desc: "Appellate workflow remains underserved by modern software",
  },
];

export default function WhyNowSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-whynow-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        WHY NOW
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-8 leading-tight">
        The market is ready for legal workflow automation
      </h1>

      <div className="flex-1 flex items-center min-h-0">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 w-full">
          {factors.map((f, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center p-4 sm:p-5 bg-slate-50 rounded-xl border border-slate-100"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                <f.icon className="h-5 w-5 sm:h-6 sm:w-6 text-blue-600" />
              </div>
              <h3 className="text-sm font-semibold text-slate-900 mb-1.5 font-heading">
                {f.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-body">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      <p className="text-sm text-slate-500 mt-4 text-center font-body">
        Timing is ideal for a software-first entrant to define the category
      </p>
    </div>
  );
}
